<script setup>
import { trans } from '@elements/translation';
</script>

<template>
  <p class="space-helper">
    {{ trans('space.contact.helper') }}
  </p>
</template>
